import { Clock, RotateCcw, CheckCircle2, XCircle } from 'lucide-react';
import type { Approval } from '../../types/approvals';
import { useApprovalStore } from '../../stores/approvalStore';
import EmptyState from '../common/EmptyState';
import ApprovalCard from './ApprovalCard';

const COLUMNS = [
  { key: 'pending' as const, label: 'Pending', icon: Clock },
  { key: 'revision_requested' as const, label: 'Revision Requested', icon: RotateCcw },
  { key: 'approved' as const, label: 'Approved', icon: CheckCircle2 },
  { key: 'rejected' as const, label: 'Rejected', icon: XCircle },
];

interface ApprovalKanbanProps {
  onApprovalClick: (approval: Approval) => void;
}

export default function ApprovalKanban({ onApprovalClick }: ApprovalKanbanProps) {
  const approvals = useApprovalStore((s) => s.approvals);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {COLUMNS.map((col) => {
        const columnApprovals = approvals.filter((a) => a.status === col.key);
        const Icon = col.icon;

        return (
          <div key={col.key} className="flex flex-col gap-3">
            <div className="flex items-center gap-2 px-1">
              <Icon className="h-4 w-4 text-text-muted" />
              <h3 className="text-sm font-medium text-text-primary">{col.label}</h3>
              <span className="bg-bg-tertiary rounded-full px-2 text-xs text-text-muted">
                {columnApprovals.length}
              </span>
            </div>

            <div className="flex flex-col gap-2 min-h-[120px]">
              {columnApprovals.length > 0 ? (
                columnApprovals.map((approval) => (
                  <ApprovalCard
                    key={approval.id}
                    approval={approval}
                    onClick={() => onApprovalClick(approval)}
                  />
                ))
              ) : (
                <EmptyState title="No approvals" description={`No ${col.label.toLowerCase()} approvals`} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
